import styled from "@emotion/styled";

import { theme } from "../../Internals/ThemeProvider/CandyTheme/ThemeShorthand";
import { UnitsLayout } from "../Navigation/UnitsLayout/UnitsLayout";
import { FormInFormContainer } from "../AttachmentForm/AttachmentForm.styles";

import { ThrowClassNameToChildren } from "./ThrowClassNameToChild";

const hideShowTransitionMs = 300;
const hideShowTransition = `${hideShowTransitionMs}ms`;

interface FormLayoutRootProps {
    hasPanel: boolean;
    widePanel: boolean;
}

export const FormLayoutRoot = styled.div<FormLayoutRootProps>(
    {
        minHeight: "100%",
        width: "100%",
        margin: "0 auto",
    },
    {
        [`${UnitsLayout}`]: {
            zIndex: 1,
            marginLeft: 0,
            height: "100%",
            position: "relative",
            transition: `margin-left ${hideShowTransition} ease-in`,
        },
    },
    props =>
        props.hasPanel && {
            [`${UnitsLayout}`]: {
                marginLeft: props.widePanel
                    ? theme(props).pageLayout.sidebar.wideModeWidth.css()
                    : theme(props).pageLayout.sidebar.width.css(),
            },

            [`${FormInFormContainer}`]: {
                [`${UnitsLayout}`]: {
                    marginLeft: 0,
                },
            },
        }
);

interface PanelOuterContainerProps {
    fixed: boolean;
    visible: boolean;
    wide: boolean;
}

export const PanelInnerContainer = styled(ThrowClassNameToChildren)({
    position: "absolute",
    overflow: "visible",
    transition: `left ease-in ${hideShowTransition}, width ease-in ${hideShowTransition}`,
    height: "100%",
});

export const PanelOuterContainer = styled.aside<PanelOuterContainerProps>(
    props => ({
        clip: "rect(auto auto auto 0)",
        position: "absolute",
        overflow: "visible",
        zIndex: 3,
        width: theme(props).pageLayout.sidebar.wideModeWidth.css(),
        transition: `width ease-in ${hideShowTransition}`,
        opacity: 1,
        height: "100%",
    }),
    props =>
        props.fixed && {
            position: "fixed",
            top: 0,
        },
    props =>
        props.visible
            ? {
                  width: props.wide
                      ? theme(props)
                            .pageLayout.sidebar.wideModeWidth.map(x => x + 16)
                            .css()
                      : theme(props)
                            .pageLayout.sidebar.width.map(x => x + 16)
                            .css(),
                  transition: `width ease-in ${hideShowTransition}, opacity cubic-bezier(0, 2, 0, 1) ${hideShowTransition}`,

                  [`${PanelInnerContainer}`]: {
                      left: 0,
                  },
              }
            : {
                  width: 0,
                  opacity: 0,
                  transition: `width ease-in ${hideShowTransition}, opacity cubic-bezier(1, -2, 1, -2) ${hideShowTransition}`,

                  [`${PanelInnerContainer}`]: {
                      left: props.wide
                          ? theme(props)
                                .pageLayout.sidebar.wideModeWidth.map(x => -x)
                                .css()
                          : theme(props)
                                .pageLayout.sidebar.width.map(x => -x)
                                .css(),
                  },
              }
);

export const ButtonMenu = styled.div<{ fixed: boolean }>(
    props => ({
        position: "absolute",
        zIndex: 2,
        top: 21,
        height: 44,
        width: 115,
        background: theme(props).keyPalette.panelBackgroundColor,
        boxShadow: `0 2px 7px 0 ${props.theme.candy.legacy.shadowColor}`,
        paddingLeft: 10,
        lineHeight: "24px",
    }),
    props => props.fixed && { position: "fixed" }
);

export const TextContainer = styled.div(props => ({
    display: "inline-block",
    verticalAlign: "middle",
    fontSize: "18px",
    color: theme(props).typography.primary.color,
    lineHeight: "22px",
    fontWeight: 600,
    marginLeft: 4,
}));

export const MenuIconContainer = styled.div(props => ({
    display: "inline-block",
    verticalAlign: "middle",
    color: theme(props).typography.primary.color,
}));

export const CentersBlock = styled.div({
    display: "inline-block",
    height: "100%",
    verticalAlign: "middle",
});
